import { gql } from "@apollo/client";
import { lensCompoundIdFragment } from "./lensCompoundIdFragment";

export const lensConnectionsFragment = gql`
    fragment LensConnections on LensWithConnections {
        lens {
            ...LensCompoundId
        }
        connections {
            connectionId
        }
    }
    ${lensCompoundIdFragment}
`;
